/** Plain text for tooltips / title (strips tags, collapses whitespace). */
export function stripHtml(html) {
  if (html == null || html === "") return "";
  return String(html)
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
